import { Typography, Box } from '@mui/material';

const HeroBanner = () => {
  return (
    <Box sx={{ mt: '4rem' }}>
      <Typography variant='h2' component='h1' sx={{ fontWeight: 'bold' }}>
        What's a Mastermind?
      </Typography>
      <Typography sx={{ mt: '1.5rem' }}>
        Monthly mastermind group meetings are the cornerstone of The 100 Club experience and is the only part of The 100
        Club that is mandatory. When you join The 100 Club, our membership team will carefully handpick other members to
        join your group, and you’ll be curated into a group with seven other founders and an experienced, executive
        facilitator. Groups are created based first on industry, then on traction (revenue, growth, users, employees,
        etc).
      </Typography>
      <Typography sx={{ mt: '1.5rem' }}>
        Mastermind group meetings can be physical or virtual, lasts 2 hours and there are 9-10 per year.
      </Typography>
      <Typography sx={{ mt: '1.5rem' }}>
        You should think of your mastermind group as your own personal board of directors - there to give you advice,
        provide critical feedback, and help you accelerate the growth of your business.
      </Typography>
      <Typography sx={{ mt: '1.5rem' }}>
        Meetings are structured and organized by your facilitator, who uses a tested playbook that allows you to focus
        on the most important parts of your personal or professional life.
      </Typography>
    </Box>
  );
};

export default HeroBanner;
